import {InitPage} from "../index";
import {ImportFile} from "../common/import_file";
import {ProductionCalendar} from "../../../assets/javascripts/App/production_calendar";
import { ScrollPage } from "../common/scroll_page";
import * as Toastr from "toastr";
import swal from "sweetalert";

declare var $;
declare var calendarState;
declare var allCellDataPath;
declare var calendarDate;
declare var headCountDataPath
declare var chartIcon;

export class ElcPlanningCalendar extends ProductionCalendar {

    initCells() {
        $(window).load( () => {
            this.loadCells();
        });
    }

    loadCells(): void {
        var daily_productions = []; // {} will create an object
        var weekdays ;
        $.ajax({
            url: `${allCellDataPath}?date=${calendarDate}`,
            success: (response) => {
                weekdays = response.weekdays
                response.sub_zones.forEach((subZone) => {
                    subZone.days_of_week.forEach((day_of_week) => {
                        if(day_of_week.productions.length > 0)
                            daily_productions.push({[day_of_week.date] : day_of_week.productions});
                        this.renderCell(day_of_week.date, subZone.id, day_of_week.productions);
                    })
                });
                this.calculateSummaryDetails(daily_productions, weekdays);
                this.hideEmptyRows();
            },
            fail: (error) => {
                console.log(error);
            }
        });
    }

    calculateSummaryDetails(weekly_productions, weekdays)
    {
        var output = []; // {} will create an object
        for(var i=0 ; i <= 6 ; i++)
        {
            output.push( { [weekdays[i]] : {'cleaning_time': 0, 'minute_rate': 0, 'has_data': false , 'sum_minutes_in_block' : 0 , 'sum_avg_emp' : 0 , 'standard_crew' : 0 , 'avg_emp' : 0 , 'sum_reported_quantity' : 0 , 'sum_expected_quantity' : 0 , 'sum_actual_cost' : 0 , 'sum_expected_cost' : 0 } });
        }
        weekly_productions.forEach(function(daily_productions){
            for (const key of Object.keys(daily_productions)) {
                var productions_wo = [];
                for(let i=0 ; i < daily_productions[key].length ; i++)
                {
                    let production = daily_productions[key][i];
                    if(!productions_wo.includes(production.wo))
                    {
                        productions_wo.push(production.wo);
                        let reports = production.reports;
                        let cleaning_reports = production.cleaning_reports;
                        for(let k=0 ; k < cleaning_reports.length ; k++){
                            let cr = cleaning_reports[k];
                            if(cr.cr_date_and_time == key)
                                output[cr.cr_day_number][key]['cleaning_time'] += cr.cr_time;
                        }
                        for(let j=0 ; j < reports.length ; j++){
                            let report = reports[j];
                            if (report.cumulative == false && report.report_date_and_time == key)
                            {

                                output[report.day_number][report.report_date_and_time]['has_data'] = true;
                                if(production.minute_rate)
                                    output[report.day_number][report.report_date_and_time]['minute_rate'] = production.minute_rate;
                                if(!production.rework && production.standard != null)
                                {
                                    output[report.day_number][report.report_date_and_time]['sum_minutes_in_block'] += report.minutes_in_block;
                                    output[report.day_number][report.report_date_and_time]['sum_avg_emp'] += report.run_time;
                                    output[report.day_number][report.report_date_and_time]['sum_reported_quantity'] += report.reported_quantity;
                                    output[report.day_number][report.report_date_and_time]['sum_expected_quantity'] += report.expected_quantity;
                                }
                                output[report.day_number][report.report_date_and_time]['standard_crew'] = report.standard_crew;
                                output[report.day_number][report.report_date_and_time]['sum_actual_cost'] += report.actual_cost;
                                output[report.day_number][report.report_date_and_time]['sum_expected_cost'] += report.expected_cost;
                            }
                        }
                        output.forEach(function(daily_output){
                            for (const sub_key of Object.keys(daily_output)) {
                                daily_output[sub_key]['avg_emp'] += (daily_output[sub_key]['sum_avg_emp'] * daily_output[sub_key]['standard_crew'] );
                                daily_output[sub_key]['sum_avg_emp'] = 0
                            }
                        });
                    }
                }
            }
        });
        this.showValuesInSummaryTable(output)
        //console.log(output);
    }

    showValuesInSummaryTable(summary_details)
    {
        $('.summary-cell').each(function(i, obj) {
            var cellDate = $(obj).data('date');
            var zoneId   = $(obj).data('zone');
            if(summary_details[i][cellDate]['has_data'] == true)
            {
                summary_details[i][cellDate]['sum_actual_cost'] += (summary_details[i][cellDate]['cleaning_time'] * summary_details[i][cellDate]['minute_rate']);
                summary_details[i][cellDate]['sum_expected_cost'] += (summary_details[i][cellDate]['cleaning_time'] * summary_details[i][cellDate]['minute_rate']);
                var hc_percent = ((((summary_details[i][cellDate]['sum_minutes_in_block'] + summary_details[i][cellDate]['cleaning_time']) / 450) / ((summary_details[i][cellDate]['avg_emp'] + summary_details[i][cellDate]['cleaning_time']) / 450)) * 100).toFixed(0);
                var units_percent = ((summary_details[i][cellDate]['sum_reported_quantity'] / summary_details[i][cellDate]['sum_expected_quantity']) * 100).toFixed(0);
                var eff_percent = ((summary_details[i][cellDate]['sum_expected_cost'] / summary_details[i][cellDate]['sum_actual_cost']) * 100).toFixed(0);
                $(obj).find('.head-count').text(((summary_details[i][cellDate]['sum_minutes_in_block'] + summary_details[i][cellDate]['cleaning_time']) / 450).toFixed(0));
                $(obj).find('.standard-count').text(((summary_details[i][cellDate]['avg_emp'] + summary_details[i][cellDate]['cleaning_time']) / 450).toFixed(0));
                if(parseFloat(hc_percent) >= 100.5)
                {
                    $(obj).find('.hc-variance').addClass('sn-elc-red');
                    $(obj).find('.hc-percent').addClass('sn-elc-red');
                }
                else
                {
                    $(obj).find('.hc-variance').addClass('sn-elc-green');
                    $(obj).find('.hc-percent').addClass('sn-elc-green');

                }
                $(obj).find('.hc-variance').text((((summary_details[i][cellDate]['sum_minutes_in_block'] + summary_details[i][cellDate]['cleaning_time']) / 450) - ((summary_details[i][cellDate]['avg_emp'] + summary_details[i][cellDate]['cleaning_time']) / 450)).toFixed(0));
                if ((summary_details[i][cellDate]['avg_emp'] + summary_details[i][cellDate]['cleaning_time']) != 0)
                    $(obj).find('.hc-percent').text( hc_percent + '%');
                else
                    $(obj).find('.hc-percent').text('0%');
                $(obj).find('.actual-units').text((summary_details[i][cellDate]['sum_reported_quantity']).toFixed(0));
                $(obj).find('.standard-units').text((summary_details[i][cellDate]['sum_expected_quantity']).toFixed(0));
                if(parseFloat(units_percent) >= 95)
                {
                    $(obj).find('.units-variance').addClass('sn-elc-green');
                    $(obj).find('.units-percent').addClass('sn-elc-green');
                }
                else
                {
                    $(obj).find('.units-variance').addClass('sn-elc-red');
                    $(obj).find('.units-percent').addClass('sn-elc-red');
                }
                $(obj).find('.units-variance').text((summary_details[i][cellDate]['sum_reported_quantity'] - summary_details[i][cellDate]['sum_expected_quantity']).toFixed(0));
                if (summary_details[i][cellDate]['sum_expected_quantity'] != 0)
                    $(obj).find('.units-percent').text( units_percent + '%');
                else
                    $(obj).find('.units-percent').text('0%');
                $(obj).find('.actual-eff').text('$ ' + (summary_details[i][cellDate]['sum_actual_cost']).toFixed(0));
                $(obj).find('.standard-eff').text('$ ' + (summary_details[i][cellDate]['sum_expected_cost']).toFixed(0));
                if(parseFloat(eff_percent) >= 95)
                {
                    $(obj).find('.eff-variance').addClass('sn-elc-green');
                    $(obj).find('.eff-percent').addClass('sn-elc-green');
                }
                else
                {
                    $(obj).find('.eff-variance').addClass('sn-elc-red');
                    $(obj).find('.eff-percent').addClass('sn-elc-red');
                }
                if(summary_details[i][cellDate]['sum_expected_cost'] - summary_details[i][cellDate]['sum_actual_cost'] >= 0)
                    $(obj).find('.eff-variance').text('$ ' + (summary_details[i][cellDate]['sum_expected_cost'] - summary_details[i][cellDate]['sum_actual_cost']).toFixed(0));
                else
                    $(obj).find('.eff-variance').text('$ (' + ((summary_details[i][cellDate]['sum_expected_cost'] - summary_details[i][cellDate]['sum_actual_cost']) * -1 ).toFixed(0) + ')');
                if (summary_details[i][cellDate]['sum_actual_cost'] != 0)
                    $(obj).find('.eff-percent').text( eff_percent + '%');
                else
                    $(obj).find('.eff-percent').text('0%');
            }
        });
    }

    renderCell(date: string, subZoneId: number, productions: any) {
        const _element = $('.cell[data-date="' + date + '"][data-sub-zone-id="' + subZoneId + '"]');
        let data = "";
        productions.forEach((e, index) => {
            if(calendarState == "planning")
            {
                if(e.status == 'planned')
                {
                    data += `<div draggable="true" id="${e.id}"  class="event productionElement" data-edit-url="${e.edit_url}" style=' text-align: left; padding-bottom: 10px; margin-bottom: 10px; padding-top:5px' onclick='window.ProductionCalendar.loadEditProduction(this)'>`

                }
                else if (e.status == 'firmed'|| e.status == 'shift_paused' || e.status == 'completed')
                {
                    data += `<div class="productionElement" data-edit-url="${e.edit_url}" style=' text-align: left; padding-bottom: 10px; margin-bottom: 10px; padding-top:5px' onclick='window.ProductionCalendar.loadEditProduction(this)'>`
                }
                else
                {
                    data += "<div class='productionElement' style='text-align: left; padding-bottom: 10px; margin-bottom: 10px; padding-top:5px' onclick=\"swal('','The status of production is "+ e.status.toUpperCase() + ", You can not edit that!','warning')\">";
                }
            }
            else
            {
                data += `<div class="productionElement" data-edit-url="${e.edit_url}" style='border-bottom: 1px black solid; text-align: left; padding-bottom: 10px; margin-bottom: 10px; padding-top:5px;' onclick='window.ProductionCalendar.loadEditProduction(this)'>`
            }
            if(e.wo_index)
            {
                data += `<span class="sn-group-circle"> ${e.wo_index} </span>`
            }
            data += `<center><b>${e.start_time} - ${e.end_time}</b></center>`
            data += `<center><span class="sn-seperator-cells " style="color:grey;" >Customer </span> <b class="sn-seperator-cells "> ${e.customer_name}</b></center>`
            data += `<span style="color:grey" class='sn-right-padd'>WO#</span><b> ${e.wo}</b>`
            if(e.rework)
                data += `<span style="color:#fff; background-color:#eb3323; float: right; padding: 0px 3px; font-size: smaller" class='bold'>Rework</span><br>`
            else
                data += `<br/>`
            data += `<span style="color:grey" class='sn-right-padd'>SO#</span><b> ${e.so}</b><br>`
            data += `<span style="color:grey" class='sn-right-padd'>PO#</span><b> ${e.po}</b><br>`
            data += `<span style="color:grey;" class='sn-right-padd'>Item# </span> <b > ${e.item_alu}</b><br>`
            data += `<span style="color:grey" class="sn-right-padd"> Name </span> <b class="sn-small-text"> ${e.name}</b><br>`
            data += `<span style="color:grey" class="">QTY </span> <b class=''> ${e.quantity} ${e.measure_unit}</b>`
            data += ` | <span style="color:grey">Progress </span> <b> ${e.progress}% </b>`

            data += `<table class='sn-data-table' style='border:none !important; margin-top: 5px !important; margin-bottom: 3px;'> <tr style='border:none !important; height: 39px'> <th style='float: left; border: none !important'><span style=' text-align: center; font-size: 0.65vw; width: 60px; display: inline-block; border: 1px solid;'>`
            if(e.standard_edit_url)
                data += `<small><a href='${e.standard_edit_url}' onclick="$('.productionElement').attr('onclick','');">STD HC </a></small>`
            else
                data += `<small>STD HC</small>`
            if(e.std_hc == 0 )
                data += `<br/><b style='width: 100%; display: inline-block; background-color:#eb3323; color:#fff; border-top: 1px solid #000'> ${e.std_hc} </b>`
            else
                data += `<br/><b style='width: 100%; display: inline-block; border-top: 1px solid #000'> ${e.std_hc} </b>`
            data += `</span></th>`
            if(calendarState != "planning")
                data += ` <th style='width:15%; border:none !important; vertical-align: middle'><a href='${e.chartPath}' > ${chartIcon} </a></th> </tr> </table>`
            else
                data += ` <th style='width:15%; border:none !important; vertical-align: middle'></th> </tr> </table>`

            if(calendarState != "planning")
            {
                let reports = e.reports;
                var output = {}; // {} will create an object
                output = { 'sum_minutes_in_block' : 0 , 'sum_run_time' : 0 , 'standard_crew' : 0 , 'sum_reported_quantity' : 0 , 'sum_expected_quantity' : 0 , 'sum_actual_cost' : 0 , 'sum_expected_cost' : 0 } ;
                let prod_var_hc = 0.0;
                let eff_percent = 0.0;
                var var_hc_class='';
                var var_units_class = '';
                var eff_class= '';
                var var_hc = 0.0;
                var var_units = 0.0;
                var var_dollar = 0.0;
                var startSign = '';
                var endSign = '';
                var var_crew = 0;
                var current_day_report = false;
                for(let j=0 ; j < reports.length ; j++){
                    let report = reports[j];
                    if (report.cumulative == false && report.report_date_and_time == date)
                    {
                        current_day_report = true;
                        output['sum_minutes_in_block'] += report.minutes_in_block;
                        output['sum_run_time'] += report.run_time;
                        output['sum_reported_quantity'] += report.reported_quantity;
                        output['sum_expected_quantity'] += report.expected_quantity;
                        output['sum_actual_cost'] += report.actual_cost;
                        output['sum_expected_cost'] += report.expected_cost;
                    }
                    if (report.cumulative == true)
                        output['standard_crew'] = report.standard_crew
                }
                if(output['sum_run_time'] != 0)
                    prod_var_hc = (output['sum_minutes_in_block'] / output['sum_run_time']); //actual_crew
                else
                    prod_var_hc = 0;
                if(output['standard_crew'] == 0)
                    var_crew = 0
                else
                    var_crew = (prod_var_hc / e.std_hc) * 100
                if(var_crew >= 100.5 || e.rework)
                    var_hc_class = 'sn-elc-red';
                else
                    var_hc_class = 'sn-elc-green';
                var_hc = parseFloat((prod_var_hc - output['standard_crew']).toFixed(0));
                if(e.rework || e.standard == null)
                    var_units = 0;
                else
                    var_units = parseFloat((output['sum_reported_quantity'] - output['sum_expected_quantity']).toFixed(0));
                if(output['sum_actual_cost'] == 0)
                    eff_percent = 0
                else
                    eff_percent = (output['sum_expected_cost'] / output['sum_actual_cost']) * 100;
                if(eff_percent >= 95)
                {
                    var_units_class = 'sn-elc-green';
                    eff_class = 'sn-elc-green';
                }
                else
                {
                    var_units_class = 'sn-elc-red';
                    eff_class = 'sn-elc-red';

                }
                var_dollar = parseFloat((output['sum_expected_cost'] - output['sum_actual_cost']).toFixed(0))
                if(var_dollar < 0)
                {
                    startSign = "$ (";
                    endSign = ")";
                }
                else
                {
                    startSign = "$ ";
                    endSign = "";
                }
                if(current_day_report) //reports.length > 0
                    data += `<table class='sn-data-table' style='font-size: 0.65vw !important; margin-top: 1px'> <tr> <th> +/- </th> <th colspan='3'> Fav (Unfav) </th></tr><tr> <th>Var HC</th> <th> Var Units</th> <th>Var $</th> <th> Eff % </th> </tr> <tr> <th class= "${var_hc_class}" >  ${var_hc}  </th> <th class='${var_units_class}'> ${var_units} </th> <th class='${eff_class}'> ${startSign}${Math.abs(var_dollar)}${endSign}</th> <th class='${eff_class}'> ${eff_percent.toFixed(0)}% </th></tr> </table>`
                else
                    data += `<table class='sn-data-table' style='font-size: 0.65vw !important; margin-top: 1px'> <tr> <th> +/- </th> <th colspan='3'> Fav (Unfav) </th></tr><tr> <th>Var HC</th> <th> Var Units</th> <th>Var $</th> <th> Eff % </th> </tr> <tr> <th >  </th> <th ></th> <th ></th> <th >  </th></tr> </table>`

            }
            if(calendarState != "planning")
            {
                //data += `<span style="color:grey">HC</span><b> ${e.emp_count} </b> | `
                //data += `<span style="color:grey">PPM</span><b> ${e.ppm} </b>`
            }
            if(e.note)
            {
                data += `<small style="color:grey">Note</small><span style="color: red"> <b> ${e.note.substr(0, 15)}</b></span>`
                if(e.note.length > 15)
                    data += `<b><small><span data-toggle='tooltip' data-placement='top' title='${e.note}' class='hover-cursor-pointer'> ... </span> </small></b>`
                data += `<br/>`
            }
            data += "<center><span class='label label-" + this.loadStatus(e.status) + "'>" + e.status.toUpperCase() + "</span></center>";
            if(calendarState == "planning")
                data += `<hr style='padding-bottom: 0px; margin-bottom: 10px; background-color: #000; border: none; height: 1px; margin-top:8px'/>`

            data += `</div>`
        });
        if (calendarState == "planning") {
            data += `<br>`
            data += "<span class='create-new-production' data-date='" + date + "' data-sub-zone-id='" + subZoneId + "' onclick='window.ProductionCalendar.loadNewProduction(this)'>";
            data += " <i class='fa fa-plus-circle add-new-production'>&nbsp;</i></span>";
        }
        _element.attr('style','vertical-align: top !important; padding-right: 2px !important; padding-left: 2px !important');
        _element.html(data)
    }

    hideEmptyRows() {
        $("#productionTable tbody tr").each(function(index){
            if( $(this).find(".productionElement").length == 0 ){
                $(this).hide();
            }
            else
            {
                $(this).show();
            }
        });
    }

    refreshPage(): void {
        super.loadCells();
    }

    loadStatus(e: string) {
        if (e == "completed") {
            return "success";
        }
        else if (e == "in_process") {
            return "middle";
        }
        else if (e == "firmed") {
            return "warning";
        }
        else if (e == "paused") {
            return "danger";
        }
        else if (e == "cleaning") {
            return "muted";
        }
        else {
            return "primary";
        }
    }

    notification_production(message: string, type: string) {
        switch(type) {
            case 'success':
                Toastr.success(message);
                break;
            case 'info':
                Toastr.info(message);
                break;
            case 'warning':
                Toastr.warning(message);
                break;
            case 'error':
                Toastr.error(message);
                break;
          }
    }
}

export function LoadPage() {
    InitPage("elc planning_calendar", () => {
        if ($(".planning-calendar").length > 0) {
            window.ProductionCalendar = new ElcPlanningCalendar();
            window.ProductionCalendar.initCells();

            // const sp = new ScrollPage();
            const i_f = new ImportFile();
        }
    });
}
